module.exports = __webpack_public_path__ + "static/MATRADE-05a37b4174ddcb04dca5f2a889e6f7cc.png";